import { me, useGame } from "../store";
import { QuarterReport } from "../online/QuarterReport";
import { Feedback } from "./Feedback";
import { Cousins } from "./Cousins";
import { DesignDesk } from "./DesignDesk";
import { PrintRun } from "./PrintRun";
import { Reviews } from "./Reviews";
import { Market } from "./Market";
import { Products } from "./Products";
import { StaffScreen } from "./Staff";
import { Finances } from "./Finances";
import { Research } from "./Research";
import { Menu } from "./Menu";
import { Achievements } from "./Achievements";
import { FollowUp } from "./FollowUp";
import { MetaScreen } from "./Meta";
import { Decision } from "./Decision";
import { PlaytestScreen } from "./Playtest";
import { Finale, finaleSeen } from "./Finale";
import { Launch } from "./Launch";
import { Imprints } from "./Imprints";
import { Conventions } from "./Conventions";

export function Screens() {
  const screen = useGame((s) => s.screen);
  const game = useGame((s) => s.game);
  const pending = me(game)?.pending ?? [];
  const visiting = useGame.getState().visiting;
  // the first time a season ends, the awards show opens by itself
  if (!screen && game?.finale && !finaleSeen(game.seed) && !visiting) return <Finale />;
  if (!screen && pending.length && !visiting) return <Decision id={pending[0].id} />;
  if (!screen) return null;
  switch (screen.kind) {
    case "design":
      return <DesignDesk projectId={screen.projectId} licence={screen.licence} back={screen.back} />;
    case "followup":
      return <FollowUp productId={screen.productId} kind={screen.line} />;
    case "meta":
      return <MetaScreen productId={screen.productId} />;
    case "playtest":
      return <PlaytestScreen projectId={screen.projectId} />;
    case "print":
      return <PrintRun projectId={screen.projectId} productId={screen.productId} />;
    case "reviews":
      return <Reviews productId={screen.productId} />;
    case "market":
      return <Market />;
    case "products":
      return <Products />;
    case "staff":
      return <StaffScreen />;
    case "finances":
      return <Finances />;
    case "research":
      return <Research />;
    case "menu":
      return <Menu />;
    case "achievements":
      return <Achievements />;
    case "finale":
      return <Finale />;
    case "launch":
      return <Launch productId={screen.productId} />;
    case "decision":
      return <Decision id={screen.id} />;
    case "quarter":
      return <QuarterReport />;
    case "feedback":
      return <Feedback />;
    case "cousins":
      return <Cousins />;
    case "imprints":
      return <Imprints />;
    case "conventions":
      return <Conventions />;
  }
}
